// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__7YMjt.styles_ocean-50__MUFFS {
  color: #e6f2ff;
}

.styles_color__7YMjt.styles_ocean-100__ULj\\+d {
  color: #e6f2ff;
}

.styles_color__7YMjt.styles_ocean-200__6TG0g {
  color: #b3daff;
}

.styles_color__7YMjt.styles_ocean-300__veQer {
  color: #7abfff;
}

.styles_color__7YMjt.styles_ocean-400__f8377 {
  color: #2392fb;
}

.styles_color__7YMjt.styles_ocean-500__tTy3U {
  color: #0074e0;
}

.styles_color__7YMjt.styles_ocean-600__2yfb1 {
  color: #043571;
}

.styles_color__7YMjt.styles_space-50__\\+CgWI {
  color: #f0f0f0;
}

.styles_color__7YMjt.styles_space-100__\\+TKML {
  color: #e3e3e3;
}

.styles_color__7YMjt.styles_space-200__iQWoD {
  color: #bfbfbf;
}

.styles_color__7YMjt.styles_space-300__PA4LM {
  color: gray;
}

.styles_color__7YMjt.styles_space-400__Yy6Uz {
  color: #616161;
}

.styles_color__7YMjt.styles_space-500__JGMP\\+ {
  color: #283439;
}

.styles_color__7YMjt.styles_gray-50__6G8YJ {
  color: #eff3f6;
}

.styles_color__7YMjt.styles_gray-100__Kw6GM {
  color: #e6ecef;
}

.styles_color__7YMjt.styles_gray-200__PNt6H {
  color: #cfd8de;
}

.styles_color__7YMjt.styles_gray-300__OAWk0 {
  color: #a8b9c2;
}

.styles_color__7YMjt.styles_gray-400__FNOQH {
  color: #7e98a5;
}

.styles_color__7YMjt.styles_gray-500__c3CQb {
  color: #738f9c;
}

.styles_color__7YMjt.styles_green-50__1wBN5 {
  color: #e3fdf6;
}

.styles_color__7YMjt.styles_green-100__-0qSK {
  color: #c5f6ea;
}

.styles_color__7YMjt.styles_green-200__SEJaH {
  color: #69ddc2;
}

.styles_color__7YMjt.styles_green-300__bsssC {
  color: #45bfa3;
}

.styles_color__7YMjt.styles_green-400__Vlb2r {
  color: #1cab8a;
}

.styles_color__7YMjt.styles_green-500__QV7cG {
  color: #128268;
}

.styles_color__7YMjt.styles_red-50__j5zrd {
  color: #fff0f3;
}

.styles_color__7YMjt.styles_red-100__Q38me {
  color: #f9d2db;
}

.styles_color__7YMjt.styles_red-200__A4ysu {
  color: #f8b4c4;
}

.styles_color__7YMjt.styles_red-300__2uJ04 {
  color: #e85e81;
}

.styles_color__7YMjt.styles_red-400__yCnCw {
  color: #e23661;
}

.styles_color__7YMjt.styles_red-500__FYshI {
  color: #b82348;
}

.styles_color__7YMjt.styles_yellow-50__aVccZ {
  color: #fffae6;
}

.styles_color__7YMjt.styles_yellow-100__6bwuc {
  color: #fff0b3;
}

.styles_color__7YMjt.styles_yellow-200__H86f1 {
  color: #ffe380;
}

.styles_color__7YMjt.styles_yellow-300__-3dwv {
  color: #ffcf57;
}

.styles_color__7YMjt.styles_yellow-400__cruSp {
  color: #ffc60a;
}

.styles_color__7YMjt.styles_yellow-500__HkYTc {
  color: #ffb700;
}

.styles_color__7YMjt.styles_orange-50__xGfkd {
  color: #fff2eb;
}

.styles_color__7YMjt.styles_orange-100__Z83PW {
  color: #ffe4d6;
}

.styles_color__7YMjt.styles_orange-200__ks3jK {
  color: #ffc69e;
}

.styles_color__7YMjt.styles_orange-300__A1jQq {
  color: #ffa047;
}

.styles_color__7YMjt.styles_orange-400__iuOzx {
  color: #ff7b42;
}

.styles_color__7YMjt.styles_orange-500__k8lLW {
  color: #ee4920;
}

.styles_color__7YMjt.styles_turquoise-50__R7-no {
  color: transparent;
}

.styles_color__7YMjt.styles_turquoise-100__v1weu {
  color: #e6fcff;
}

.styles_color__7YMjt.styles_turquoise-200__GVrbv {
  color: #b3f5ff;
}

.styles_color__7YMjt.styles_turquoise-300__uiNat {
  color: #78e2f2;
}

.styles_color__7YMjt.styles_turquoise-400__30xKT {
  color: #00c7e6;
}

.styles_color__7YMjt.styles_turquoise-500__PY0N2 {
  color: transparent;
}

.styles_color__7YMjt.styles_turquoise-600__BlkR3 {
  color: transparent;
}

.styles_color__7YMjt.styles_violet-50__UrGju {
  color: #eae6ff;
}

.styles_color__7YMjt.styles_violet-100__IPw3M {
  color: #d9d1ff;
}

.styles_color__7YMjt.styles_violet-200__gOAZ2 {
  color: #bfb3ff;
}

.styles_color__7YMjt.styles_violet-300__Jm7Gv {
  color: #9d90ea;
}

.styles_color__7YMjt.styles_violet-400__Rfjcm {
  color: #8678d9;
}

.styles_color__7YMjt.styles_violet-500__-Elou {
  color: #6f5ccc;
}

.styles_color__7YMjt.styles_snow-50__5Gs9A {
  color: white;
}

.styles_color__7YMjt.styles_snow-100__MkuIi {
  color: #f7f7f7;
}

.styles_color__7YMjt.styles_snow-200__hNFKF {
  color: #f0efef;
}

.styles_color__7YMjt.styles_snow-300__1icf7 {
  color: #e6e6e6;
}

.styles_color__7YMjt.styles_snow-400__DkcQU {
  color: #e1e0e0;
}

.styles_color__7YMjt.styles_snow-500__xicPz {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__So1Dc.styles_ocean__gQa\\+F {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__So1Dc.styles_ocean-light__gqpk2 {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__So1Dc.styles_green__Yt52S {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__So1Dc.styles_green-light__EKair {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__So1Dc.styles_red__scrBs {
  background-color: #e23661;
  color: white;
}

.styles_background-color__So1Dc.styles_red-light__OCA\\+b {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__So1Dc.styles_orange__BVSSZ {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__So1Dc.styles_orange-light__71710 {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__So1Dc.styles_space__khDNb {
  background-color: #616161;
  color: white;
}

.styles_background-color__So1Dc.styles_space-light__AhERR {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__So1Dc.styles_gray-light__FcPhm {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__So1Dc.styles_violet__JzWTE {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__So1Dc.styles_violet-light__1o\\+UK {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__So1Dc.styles_yellow__hakSr {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__So1Dc.styles_yellow-light__xkb-B {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__Tr5vk {
  background-color: white;
  border-bottom: 2px solid white;
  height: 66px;
  max-height: 66px;
  padding: 8px 16px ;
  padding-left: 0px ;
}
@media (min-width: 960px) {
  .styles_root__Tr5vk {
    background-color: transparent;
    padding-left: 16px ;
  }
}
.styles_root__Tr5vk .styles_roomMembersList__qjzJ5 {
  background-color: white;
  border: 2px solid #eff3f6;
  border-radius: 5px;
  box-shadow: 0 3px 5px rgba(9, 30, 66, 0.2), 0 0 1px rgba(9, 30, 66, 0.31);
  cursor: auto;
  height: auto;
  left: 0;
  margin-left: 16px ;
  max-height: 200px;
  max-width: 300px;
  position: absolute;
  top: 100%;
  z-index: 2;
}
.styles_root__Tr5vk .styles_memberItem__DCGIa {
  border-bottom: 1px solid #eff3f6;
  display: flex;
  justify-content: space-between;
  padding: 8px 16px ;
}
.styles_root__Tr5vk .styles_memberAvatarWrapper__ub1ag {
  margin-right: 8px ;
}
.styles_root__Tr5vk .styles_groupRoomIcon__y6M3u {
  margin-right: 8px ;
}
.styles_root__Tr5vk .styles_iconButton__1W\\+7G {
  background-color: white;
}
.styles_root__Tr5vk .styles_avatarWithTitleContainer__rzp4q {
  display: flex;
}
.styles_root__Tr5vk .styles_angleRightIcon__c0i2t {
  margin-left: 8px ;
}
.styles_root__Tr5vk .styles_backButton__gReX5 {
  height: auto;
  padding: 0px 16px ;
  width: auto;
}
.styles_root__Tr5vk .styles_backButton__gReX5 * {
  font-size: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/components/chat/content/header/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_media-query.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA0UJ;AE5TY;EFpBZ;IASQ,6BAAA;IACA,mBAAA;EA2UN;AACF;AAzUI;EACI,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yEAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AA2UR;AAxUI;EACI,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AA0UR;AAvUI;EACI,kBAAA;AAyUR;AAtUI;EACI,kBAAA;AAwUR;AArUI;EACI,uBAAA;AAuUR;AApUI;EACI,aAAA;AAsUR;AAnUI;EACI,iBAAA;AAqUR;AAlUI;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AAoUR;AAlUQ;EACI,eAAA;AAoUZ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    background-color: theme.color(snow-50);\n    border-bottom: 2px solid theme.color(snow-50);\n    height: 66px;\n    max-height: 66px;\n    padding: theme.spacing(1, 2);\n    padding-left: theme.spacing(0);\n\n    @include theme.mq-up(md) {\n        background-color: transparent;\n        padding-left: theme.spacing(2);\n    }\n\n    .roomMembersList {\n        background-color: theme.color(snow-50);\n        border: 2px solid theme.color(gray-50);\n        border-radius: theme.get-border-radius(md);\n        box-shadow: theme.box-shadow(md);\n        cursor: auto;\n        height: auto;\n        left: 0;\n        margin-left: theme.spacing(2);\n        max-height: 200px;\n        max-width: 300px;\n        position: absolute;\n        top: 100%;\n        z-index: 2;\n    }\n\n    .memberItem {\n        border-bottom: 1px solid theme.color(gray-50);\n        display: flex;\n        justify-content: space-between;\n        padding: theme.spacing(1, 2);\n    }\n\n    .memberAvatarWrapper {\n        margin-right: theme.spacing(1);\n    }\n\n    .groupRoomIcon {\n        margin-right: theme.spacing(1);\n    }\n\n    .iconButton {\n        background-color: theme.color(snow-50);\n    }\n\n    .avatarWithTitleContainer {\n        display: flex;\n    }\n\n    .angleRightIcon {\n        margin-left: theme.spacing(1);\n    }\n\n    .backButton {\n        height: auto;\n        padding: theme.spacing(0, 2);\n        width: auto;\n\n        * {\n            font-size: 3rem;\n        }\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:list';\n@use 'sass:map';\n\n$breakpoints: (\n    xs: 0,\n    sm: 600px,\n    md: 960px,\n    lg: 1280px,\n    xl: 1920px,\n);\n$breakpoint-keys: map.keys($breakpoints);\n$breakpoint-unit: px;\n$breakpoint-step: 0.05;\n\n@function breakpoint($breakpointName: xs) {\n    @return map.get($breakpoints, $breakpointName);\n}\n\n@mixin mq-up($breakpoint, $show-warning: true) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $index: list.index($breakpoint-keys, $breakpoint);\n\n        @if $index > 1 {\n            @media (min-width: map.get($breakpoints, $breakpoint)) {\n                @content;\n            }\n        } @else {\n            @content;\n\n            // stylelint-disable-next-line max-nesting-depth\n            @if $show-warning {\n                @warn 'Using #{$breakpoint} breakpoint as mq-up is redundant. Remove the media query.';\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq-down($breakpoint) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $upper-index: list.index($breakpoint-keys, $breakpoint) + 1;\n\n        @if $upper-index == list.length($breakpoint-keys) + 1 {\n            $lowest-breakpoint-key: list.nth($breakpoint-keys, 1);\n\n            /* stylelint-disable-next-line max-line-length */\n            @warn 'Using #{$breakpoint} breakpoint as mq-down is redundant. Use mq-up(#{$lowest-breakpoint-key}) instead.';\n\n            @include mq-up($lowest-breakpoint-key, false) {\n                @content;\n            }\n        } @else {\n            $upper-breakpoint-key: list.nth($breakpoint-keys, $upper-index);\n\n            @media (max-width: map.get($breakpoints, $upper-breakpoint-key) - $breakpoint-step) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq-between($start-breakpoint, $end-breakpoint, $show-warning: true) {\n    @if map.has-key($breakpoints, $start-breakpoint) and map.has-key($breakpoints, $end-breakpoint) {\n        $start-index: list.index($breakpoint-keys, $start-breakpoint);\n        $end-index: list.index($breakpoint-keys, $end-breakpoint);\n\n        @if $end-index == list.length($breakpoint-keys) {\n            @if $show-warning {\n                /* stylelint-disable-next-line max-line-length */\n                @warn 'Using #{$end-breakpoint} breakpoint as mq-betwen end is redundant. Use mq-up(#{$start-breakpoint}) instead.';\n            }\n\n            @include mq-up($start-breakpoint) {\n                @content;\n            }\n        } @else {\n            @if $start-index == $end-index {\n                @if $show-warning {\n                    @warn 'Start and end breakpoints are the same. Use mq-only(#{$start-breakpoint}) instead.';\n                }\n            } @else if $start-index > $end-index {\n                @if $show-warning {\n                    /* stylelint-disable-next-line max-line-length */\n                    @warn 'Start breakpoint (#{$start-breakpoint}) is bigger than end breakpoint (#{$end-breakpoint}). Remove it or change it.';\n                }\n            }\n\n            $upper-breakpoint: list.nth($breakpoint-keys, $end-index + 1);\n\n            @media\n                (min-width: map.get($breakpoints, $start-breakpoint)) and\n                (max-width: map.get($breakpoints, $upper-breakpoint) - $breakpoint-step) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Both or one of the given breakpoints (#{$start-breakpoint}, #{$end-breakpoint}) is missing.';\n    }\n}\n\n@mixin mq-only($breakpoint) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $index: list.index($breakpoint-keys, $breakpoint);\n\n        @if $index == list.length($breakpoint-keys) {\n            /* stylelint-disable-next-line max-line-length */\n            @warn 'Using #{$breakpoint} breakpoint as mq-only parameter is redundant. Use mq-up(#{$breakpoint}) instead.';\n\n            @include mq-up($breakpoint) {\n                @content;\n            }\n        } @else {\n            @include mq-between($breakpoint, $breakpoint, false) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq($condition, $breakpoint-one, $breakpoint-two: null) {\n    @if ($condition == up) {\n        @include mq-up($breakpoint-one) {\n            @content;\n        }\n    } @else if ($condition == down) {\n        @include mq-down($breakpoint-one) {\n            @content;\n        }\n    } @else if ($condition == between) {\n        @include mq-between($breakpoint-one, $breakpoint-two) {\n            @content;\n        }\n    } @else if ($condition == only) {\n        @include mq-only($breakpoint-one) {\n            @content;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__7YMjt`,
	"ocean-50": `styles_ocean-50__MUFFS`,
	"ocean-100": `styles_ocean-100__ULj+d`,
	"ocean-200": `styles_ocean-200__6TG0g`,
	"ocean-300": `styles_ocean-300__veQer`,
	"ocean-400": `styles_ocean-400__f8377`,
	"ocean-500": `styles_ocean-500__tTy3U`,
	"ocean-600": `styles_ocean-600__2yfb1`,
	"space-50": `styles_space-50__+CgWI`,
	"space-100": `styles_space-100__+TKML`,
	"space-200": `styles_space-200__iQWoD`,
	"space-300": `styles_space-300__PA4LM`,
	"space-400": `styles_space-400__Yy6Uz`,
	"space-500": `styles_space-500__JGMP+`,
	"gray-50": `styles_gray-50__6G8YJ`,
	"gray-100": `styles_gray-100__Kw6GM`,
	"gray-200": `styles_gray-200__PNt6H`,
	"gray-300": `styles_gray-300__OAWk0`,
	"gray-400": `styles_gray-400__FNOQH`,
	"gray-500": `styles_gray-500__c3CQb`,
	"green-50": `styles_green-50__1wBN5`,
	"green-100": `styles_green-100__-0qSK`,
	"green-200": `styles_green-200__SEJaH`,
	"green-300": `styles_green-300__bsssC`,
	"green-400": `styles_green-400__Vlb2r`,
	"green-500": `styles_green-500__QV7cG`,
	"red-50": `styles_red-50__j5zrd`,
	"red-100": `styles_red-100__Q38me`,
	"red-200": `styles_red-200__A4ysu`,
	"red-300": `styles_red-300__2uJ04`,
	"red-400": `styles_red-400__yCnCw`,
	"red-500": `styles_red-500__FYshI`,
	"yellow-50": `styles_yellow-50__aVccZ`,
	"yellow-100": `styles_yellow-100__6bwuc`,
	"yellow-200": `styles_yellow-200__H86f1`,
	"yellow-300": `styles_yellow-300__-3dwv`,
	"yellow-400": `styles_yellow-400__cruSp`,
	"yellow-500": `styles_yellow-500__HkYTc`,
	"orange-50": `styles_orange-50__xGfkd`,
	"orange-100": `styles_orange-100__Z83PW`,
	"orange-200": `styles_orange-200__ks3jK`,
	"orange-300": `styles_orange-300__A1jQq`,
	"orange-400": `styles_orange-400__iuOzx`,
	"orange-500": `styles_orange-500__k8lLW`,
	"turquoise-50": `styles_turquoise-50__R7-no`,
	"turquoise-100": `styles_turquoise-100__v1weu`,
	"turquoise-200": `styles_turquoise-200__GVrbv`,
	"turquoise-300": `styles_turquoise-300__uiNat`,
	"turquoise-400": `styles_turquoise-400__30xKT`,
	"turquoise-500": `styles_turquoise-500__PY0N2`,
	"turquoise-600": `styles_turquoise-600__BlkR3`,
	"violet-50": `styles_violet-50__UrGju`,
	"violet-100": `styles_violet-100__IPw3M`,
	"violet-200": `styles_violet-200__gOAZ2`,
	"violet-300": `styles_violet-300__Jm7Gv`,
	"violet-400": `styles_violet-400__Rfjcm`,
	"violet-500": `styles_violet-500__-Elou`,
	"snow-50": `styles_snow-50__5Gs9A`,
	"snow-100": `styles_snow-100__MkuIi`,
	"snow-200": `styles_snow-200__hNFKF`,
	"snow-300": `styles_snow-300__1icf7`,
	"snow-400": `styles_snow-400__DkcQU`,
	"snow-500": `styles_snow-500__xicPz`,
	"background-color": `styles_background-color__So1Dc`,
	"ocean": `styles_ocean__gQa+F`,
	"ocean-light": `styles_ocean-light__gqpk2`,
	"green": `styles_green__Yt52S`,
	"green-light": `styles_green-light__EKair`,
	"red": `styles_red__scrBs`,
	"red-light": `styles_red-light__OCA+b`,
	"orange": `styles_orange__BVSSZ`,
	"orange-light": `styles_orange-light__71710`,
	"space": `styles_space__khDNb`,
	"space-light": `styles_space-light__AhERR`,
	"gray-light": `styles_gray-light__FcPhm`,
	"violet": `styles_violet__JzWTE`,
	"violet-light": `styles_violet-light__1o+UK`,
	"yellow": `styles_yellow__hakSr`,
	"yellow-light": `styles_yellow-light__xkb-B`,
	"root": `styles_root__Tr5vk`,
	"roomMembersList": `styles_roomMembersList__qjzJ5`,
	"memberItem": `styles_memberItem__DCGIa`,
	"memberAvatarWrapper": `styles_memberAvatarWrapper__ub1ag`,
	"groupRoomIcon": `styles_groupRoomIcon__y6M3u`,
	"iconButton": `styles_iconButton__1W+7G`,
	"avatarWithTitleContainer": `styles_avatarWithTitleContainer__rzp4q`,
	"angleRightIcon": `styles_angleRightIcon__c0i2t`,
	"backButton": `styles_backButton__gReX5`
};
export default ___CSS_LOADER_EXPORT___;
